import apiClient from './apiClient';

export const getPayments = ({ paidLimit = 25, cursor, takeoverLimit = 25, takeoverCursor } = {}) =>
  apiClient.get('/payments', { params: { paidLimit, cursor, takeoverLimit, takeoverCursor } });
